import React, { Component } from "react";
import Functions from "../../src/functions";

class Pagination extends Component {
  state = {
    start: 0,
    offset: 25,
    current: 0,
    totalRecords: 0,
    first: "First",
    last: "Last",
    previous: "Previous",
    next: "Next",
    loaded: false,
    replaceAttribute: "page",
  };

  constructor(props) {
    super(props);

    this.clickPage = this.clickPage.bind(this);
    let events = {};
    if (this.props.property) {
      if (this.props.property.events) {
        Object.keys(this.props.property.events).map((itm, idx) => {
          this[itm] = this.props.property.events[itm];
          this[itm] = this[itm].bind(this);
          events[itm] = this[itm];
        });
      }
    }

    this.state = {
      start: this.props.start ? this.props.start : 0,
      offset: this.props.offset ? this.props.offset : 25,
      current: this.props.current ? this.props.current : 0,
      replaceAttribute: this.props.replace
        ? this.props.replace
        : this.state.replaceAttribute,
      totalRecords: this.props.totalRecords ? this.props.totalRecords : 0,
      totalPages:
        this.props.totalRecords < this.props.offset
          ? 1
          : Math.ceil(this.props.totalRecords / this.props.offset),
    };
  }

  clickPage(page) {
    let customParameters = {
      ...this.props.manager.state.customParameters,
    };

    if (!customParameters["replace"]) {
      customParameters["replace"] = {};
    }

    customParameters["replace"][this.state.replaceAttribute] = page;

    this.props.manager.setState({ customParameters: customParameters });

    this.props.manager.refresh();
  }

  componentDidMount() {
    this.setState({ loaded: true });

    if (this.didMount) {
      this.didMount();
    }
  }

  render() {
    let output = [];

    if (this.state.loaded) {
      let pagination = [];
      if (this.state.totalPages > 1) {
        let from = this.state.current - 4 <= 0 ? 1 : this.state.current - 4;
        let to =
          from + 10 < this.state.totalPages ? from + 10 : this.state.totalPages;

        if (this.state.current > this.state.start) {
          pagination.push({ label: "First", value: this.state.start });
          pagination.push({ label: "Previous", value: this.state.current - 1 });
        }

        for (let i = from; i <= to; i++) {
          pagination.push({
            label: i,
            value: i - 1,
            isCurrent: this.state.current == i - 1 ? true : false,
          });
        }

        if (this.state.current < this.state.totalPages - 1) {
          pagination.push({ label: "Next", value: this.state.current + 1 });
          pagination.push({
            label: "Last (" + this.state.totalPages + ")",
            value: this.state.totalPages - 1,
          });
        }
      }

      pagination.map((itm, idx) => {
        let isCurrentClass = "";
        if (itm.isCurrent) {
          isCurrentClass = "active bg-orange";
        }

        output.push(
          <li className={isCurrentClass + " page-item"} key={Functions.key()}>
            <span
              className="page-link c-page-link-number pointer"
              onClick={(e) => this.clickPage(itm.value)}
            >
              {itm.label}
            </span>
          </li>
        );
      });

      return <ul className="pagination justify-content-center ">{output}</ul>;
    } else {
      return "";
    }
  }
}

export default Pagination;
